{
  "access-denied-user": "L'usuario introduït no pot accedir a aquesta Web",
  "activation": "Activació",
  "code": "Codi",
  "code-sent": "Codi enviat",
  "contact": "Contacte",
  "enter": "Entrar",
  "error-text": "Error",
  "mail": "Correu",
  "new-version-available": "Nova versió disponible",
  "password": "Contrasenya",
  "resend-wait": "Espera {{seconds}}s per tornar a enviar",
  "server-apologies": "Disculpeu les molèsties",
  "server-maintenance": "Servidor en manteniment",
  "translation-load-error": "Error al carregar les traduccions",
  "user": "Usuari",
  "user-or-password-incorrect": "Usuari o contrasenya incorrecta",
  "wait": "Espereu si us plau"
}